<mat-dialog-content>
  <h1 mat-dialog-title>Remove {{ airportSummary.name }} From Associated Airports?</h1>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button (click)="dialogRef.close(true)">Confirm</button>
  <button mat-button (click)="dialogRef.close()">Cancel</button>
</mat-dialog-actions>
